import { upgradeArray } from '@sigma-legacy-libs/essentials/lib/utils'

export const serviceName = 'operatorGroups'
export const rowStates = upgradeArray([ 'opened', 'closed', 'loading' ])
